var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"post-aside"},[_c('PostListRelated',{attrs:{"related-posts":_vm.relatedPosts}}),_c('PostListPopLat',{attrs:{"popular-posts":_vm.popularPosts,"latest-posts":_vm.latestPosts}}),_c('PostListMailing')],1)}
var staticRenderFns = []

export { render, staticRenderFns }